classText = function() {

    var self = this;

    this.x = 10;
    this.y = 50;
    this.text = '';
    this.fontSize = "20px"
    this.fontFamily = "Verdana";
    this.color = 'white';

    this.stroke = false;

    this.drawer = new function() {

        this.draw = function() {
            context.font = '' + self.fontSize + ' ' + self.fontFamily;
            context.fillStyle = self.color;
            context.fillText(self.text, self.x, self.y);

            if (false !== self.stroke) {
                context.lineWidth = self.stroke.width;
                context.strokeStyle = self.stroke.style;
                context.strokeText(self.text, self.x, self.y);
            }
        }
    }

    this.setStroke = function(stroke) {
        self.stroke = stroke;
        return self;
    }

    this.setColor = function(color) {
        self.color = color;
        return self;
    }

    this.setX = function(x) {
        self.x = x;
        return self;
    }

    this.setY = function(y) {
        self.y = y;
        return self;
    }

    this.setText = function(text) {
        self.text = text;
        return self;
    }

    this.setFontSize = function(size) {
        self.fontSize = size;
        return self;
    }

    this.setFontFamily = function(family) {
        self.fontFamily = family;
        return self;
    }

}

classVideoDrawer = function(parent) {
    var self = this;

    this.draw = function() {

        if (parent.video.readyState === 4) {

            if (parent.autoplay) {
                window['playLuckyBallsVideo'](parent.video);
            }

            context.drawImage(
                    parent.video,
                    parent.x,
                    parent.y,
                    parent.width,
                    parent.height);
        } else {
            // Postpone drawing - recursively
            console.log('######### VIDEO NOT READY FOR DRAWING! ###########');
            setTimeout(self.draw, parent.videoLoading);
        }
    }

}

classVideo = function(id) {
    this.video = document.getElementById(id);
    this.video.style.visibility = "hidden";
    this.videoLoading = 200;
    this.autoplay = true;
    this.x = 0;
    this.y = 0;
    this.width = config.canvasWidth;
    this.height = config.canvasHeight;
    this.drawer = new classVideoDrawer(this);
}

/**
 * @description Abstract classImageDrawer used as an instance within other classes.
 * @param Object parent
 * @returns {classImageDrawer}
 */
classImageDrawer = function(parent) {
    var self = this;

    // Animation
    this.sequenceNo = 0;
    this.animationFrames = new Array();
    this.loop = 0;

    this.format = function(num, places) {
        var zero = places - num.toString().length + 1;
        return Array(+(zero > 0 && zero)).join("0") + num;
    }

    this.clear = function() {
        context.clearRect(
                parent.x,
                parent.y,
                parent.width,
                parent.height);
    };

    this.draw = function() {
        try {

            if (parent.image.complete) {
                // Set default width (if not set in object) to prevent invisible images
                if (typeof parent.width === 'undefined' || parent.width == 0) {
                    parent.width = parent.image.width;
                }

                // Set default height (if not set in object) to prevent invisible images
                if (typeof parent.height === 'undefined' || parent.height == 0)
                {
                    parent.height = parent.image.height;
                }

                if (parent.rotation > 0) {
                    context.save();
                    context.translate(parent.x + (parent.width / 2), parent.y + (parent.height / 2));
                    context.rotate(parent.rotation * (Math.PI / 180));
                    context.drawImage(
                            parent.image,
                            -parent.width / 2,
                            -parent.height / 2,
                            parent.width,
                            parent.height);
                    context.restore();

                } else {

                    context.drawImage(
                            parent.image,
                            parent.x,
                            parent.y,
                            parent.width,
                            parent.height);
                }

            } else {
                console.log('loading' + JSON.stringify(parent.image));
                // Postpone drawing - recursively
                setTimeout(self.draw, parent.imageLoading);
            }

        } catch (error) {
            console.error('ERROR DRAWING IMAGE:' + JSON.stringify(parent.image))
        }
    };

    this.animate = function() {

        // parent.animation.sequences = parseInt(parent.animation.sequences);
        // Check if animationFrames array has enough members
        if (self.animationFrames.length !== parent.animation.sequences.length) {

            // create array of animationFrames
            for (var x in parent.animation.sequences) {
                if (typeof parent.processor !== 'undefined') {
                    // if some pre-processing is needed then get the image from processor class
                    self.animationFrames[x] = parent.processor.getAnimationImage(parent.animation.sequences[x]);
                } else {
                    // otherwise load the image source directly (from file)
                    self.animationFrames[x] = parent.animation.sequences[x];
                }
            }
        }

        if (!parent.animation.stop && !parent.animation.slowMotion) {
            switch (parent.animation.speed) {
                case 1:
                    self.sequenceNo = (self.loop == 3) ? self.sequenceNo + 1 : self.sequenceNo;
                    break;
                case 2:
                    self.sequenceNo = (self.loop == 2 || self.loop == 3) ? self.sequenceNo + 1 : self.sequenceNo;
                    break;
                case 3:
                    self.sequenceNo = (self.loop == 1 || self.loop == 2 || self.loop == 3) ? self.sequenceNo + 1 : self.sequenceNo;
                    break;
                default:
                    self.sequenceNo = self.sequenceNo + 1;
            }
        }

        self.loop++;

        if (self.sequenceNo == parent.animation.sequences.length) {
            // if loopFrom parameter is given - loop from that sequence instead of 0 sequence
            self.sequenceNo = (typeof parent.animation.loopFrom !== 'undefined') ? parent.animation.loopFrom : 0;
        }

        if (self.loop > 3) {
            self.loop = 0;
        }

        // Replace image property of the class
        parent.image = self.animationFrames[self.sequenceNo];
        self.draw();
    };

};

/**
 * @description Base class classImage used as a main (or parent) class for graphic elements.
 * @returns {classImage}
 */
classImage = function(image) {
    var self = this;

    this.rotation = 0;
    // autoclear area between two drawing loops
    this.autoclear = false;

    if (typeof image == 'object') {
        this.image = image;
    }

    this.animation = {
        show: false,
        stop: false,
        sequences: new Array(),
        slowMotion: false,
        speed: 3
    };

    this.setImageProcessor = function(processor) {
        self.processor = processor;
        return self;
    }

    this.rotate = function(rotation) {
        self.rotation = rotation;
    }

    // Interval to retry image loading (recursively!!!)
    this.imageLoading = 20;

    this.x = 0;
    this.y = 0;
    this.drawer = new classImageDrawer(this);

    this.stopAnimation = function() {
        self.animation.stop = true;
        return self;
    }

    this.startAnimation = function() {
        self.animation.stop = false;
        return self;
    }

    this.setAnimation = function(object) {
        self.animation = object;
        return self;
    }

    this.setX = function(x) {
        self.x = x;
        return self;
    }

    this.setY = function(y) {
        self.y = y;
        return self;
    }

    this.setWidth = function(width) {
        self.width = width;
        return self;
    }

    this.setHeight = function(height) {
        self.height = height;
        return self;
    }
}

classScene = function() {
    var self = this;

    this.elements = new Object();
    this.elementsPriority = new Object();
    this.counter = 0;
    this.counterPriority = 0;

    this.add = function(object, id, priority) {
        if (priority === true) {
            if (typeof self.elementsPriority[id] !== 'undefined') {
                console.log('%c CRITICAL: Duplicate scene ID "' + id + '"!', 'background: red; color: #fff; font-size:20px');
                console.log('CRITICAL: Duplicate scene ID "' + id + '"!');
            } else {
                self.elementsPriority[id] = object;
            }
            this.counterPriority++;
        } else {
            if (typeof self.elements[id] !== 'undefined') {
                console.log('%c CRITICAL: Duplicate scene ID "' + id + '"!', 'background: red; color: #fff; font-size:20px');
                console.log('CRITICAL: Duplicate scene ID "' + id + '"!');
            } else {
                self.elements[id] = object;
            }
            this.counter++;
        }
    }

    this.remove = function(id) {
        delete scene.elements[id];
    }
}

classCanvas = function() {
    var self = this;

    this.initialize = function() {
        config = {
            'canvasWidth': 750,
            'canvasHeight': 441
        }

        c = document.getElementById('mycanvas');
        context = c.getContext('2d');
        scene = new classScene();

        c.width = config.canvasWidth;
        c.height = config.canvasHeight;
    }

    this.reset = function() {
        scene = null;
        delete(scene);
        scene = new classScene();
        self.clear();
    }

    this.clear = function() {
        context.clearRect(
                0,
                0,
                config.canvasWidth,
                config.canvasHeight);
    }

    // Run the loop to draw all scene elements
    this.loop = function() {
        // Clear canvas for re-drawing
        self.clear();
        for (key in scene.elements) {
            if (typeof scene.elements[key] === 'object') {
                // Hook
                if (typeof scene.elements[key].hookBeforeClear === 'function') {
                    scene.elements[key].hookBeforeClear();
                }

                if (scene.elements[key].autoclear) {
                    scene.elements[key].drawer.clear();
                }
                // Hook
                if (typeof scene.elements[key].hookBeforeDraw === 'function') {
                    scene.elements[key].hookBeforeDraw();
                }

                if (typeof scene.elements[key].animation !== 'undefined' && scene.elements[key].animation.show === true) {
                    scene.elements[key].drawer.animate();
                } else {
                    scene.elements[key].drawer.draw();
                }

                // Hook
                if (typeof scene.elements[key].hookAfterDraw === 'function') {
                    scene.elements[key].hookAfterDraw();
                }

            } else {
                console.log(typeof scene.elements[key]);
            }

        }

        for (key in scene.elementsPriority) {

            if (typeof scene.elementsPriority[key] === 'object') {

                // Hook
                if (typeof scene.elementsPriority[key].hookBeforeClear === 'function') {
                    scene.elementsPriority[key].hookBeforeClear();
                }

                if (scene.elementsPriority[key].autoclear) {
                    scene.elementsPriority[key].drawer.clear();
                }

                // Hook
                if (typeof scene.elementsPriority[key].hookBeforeDraw === 'function') {
                    scene.elementsPriority[key].hookBeforeDraw();
                }

                if (typeof scene.elementsPriority[key].animation !== 'undefined' && scene.elementsPriority[key].animation.show === true) {
                    scene.elementsPriority[key].drawer.animate();
                } else {
                    scene.elementsPriority[key].drawer.draw();
                }

                // Hook
                if (typeof scene.elementsPriority[key].hookAfterDraw === 'function') {
                    scene.elementsPriority[key].hookAfterDraw();
                }

            } else {
                console.log(typeof scene.elementsPriority[key])
            }

        }

        requestAnimationFrame(self.loop);
    }

}



//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/js/draw.js
// module id = 870
// module chunks = 0